import { Link } from 'react-router-dom'
import React, { useEffect, useMemo, useState } from "react";
import hero1 from '../asset/hero.jpg'
import hero2 from '../asset/hero2.png'
import hero3 from '../asset/hero3.png'
import hero4 from '../asset/hero4.jpg'
import scienceStudents from '../asset/science students.jpg'
import games from '../asset/games.jpg'

const slides = [
	{ src: hero1, alt: "Students celebrating during sports day" },
	{ src: hero2, alt: "Students collaborating on a science project" },
	{ src: hero3, alt: "Boarding students sharing a laugh outdoors" },
	{ src: hero4, alt: "GreatGrace students on stage" }
];

const sectionImages = [
	{ src: scienceStudents, alt: "Science students" },
	{ src: games, alt: "Students playing games" }
];

export default function Hero() {
	const [activeIndex, setActiveIndex] = useState(0);
	const [prevIndex, setPrevIndex] = useState(slides.length - 1);
	const [sectionImageIndex, setSectionImageIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setActiveIndex((current) => {
				const next = (current + 1) % slides.length;
				setPrevIndex(current);
				return next;
			});
		}, 4500);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			setSectionImageIndex((current) => (current + 1) % sectionImages.length);
		}, 4000);

		return () => clearInterval(interval);
	}, []);

	const getSlideClasses = (idx) => {
		if (idx === activeIndex) {
			return "translate-x-0 scale-105 opacity-100 z-30 shadow-2xl shadow-slate-900/40";
		}

		if (idx === prevIndex) {
			return "-translate-x-full scale-95 opacity-80 z-20";
		}

		return "translate-x-full scale-110 opacity-0 z-10";
	};

	const motionParticles = useMemo(() => (
		Array.from({ length: 12 }).map((_, idx) => ({
			delay: `${idx * 0.8}s`,
			left: `${Math.random() * 100}%`,
			duration: `${14 + (idx % 5)}s`
		}))
	), []);

	return (
		<>
			<div className="relative h-screen w-full overflow-hidden bg-slate-950">
				<div className="pointer-events-none absolute inset-0 overflow-hidden">
					<div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900/80 to-slate-900/30" />
					<div
						className="absolute inset-0 animate-hero-pulse opacity-60 mix-blend-screen"
						style={{
							background: "radial-gradient(circle at 20% 20%, rgba(14,165,233,0.4), transparent 55%)"
						}}
					/>
					<div
						className="absolute inset-y-0 -left-1/3 w-[180%] animate-hero-sweep opacity-50 blur-3xl"
						style={{
							background: "linear-gradient(120deg, rgba(14,165,233,0.45), transparent 55%, rgba(12,74,110,0.6))"
						}}
					/>
					<div className="absolute inset-0">
						{motionParticles.map((particle, idx) => (
							<span
								key={`particle-${idx}`}
								className="absolute h-24 w-px bg-gradient-to-b from-transparent via-sky-200 to-transparent opacity-70 animate-hero-trace"
								style={{
									left: particle.left,
									animationDuration: particle.duration,
									animationDelay: particle.delay
								}}
							/>
						))}
					</div>
				</div>

				<div className="relative h-full">
					<div className="pointer-events-none absolute inset-0 z-50 flex items-center justify-start px-6 text-left sm:px-10 lg:px-16">
						<h1 className="max-w-xl text-3xl font-extrabold uppercase tracking-tight text-white drop-shadow-[0_15px_45px_rgba(0,0,0,0.85)] sm:text-5xl lg:text-6xl">
							A vibrant school for Nursery to Primary &amp; a day and boarding community for secondary
						</h1>
					</div>

					{slides.map((slide, idx) => (
						<div
							key={slide.src}
							className={`absolute inset-0 h-full w-full transition-all duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] will-change-transform ${getSlideClasses(idx)}`}
						>
							<img
								src={slide.src}
								alt={slide.alt}
								className="h-full w-full object-cover"
							/>
							<div className="absolute left-8 top-8 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1 text-sm font-semibold uppercase tracking-[0.2em] text-white/80 backdrop-blur">
								<span className="h-2 w-2 rounded-full bg-sky-300 animate-ping" />
								{/* {slide.label} */}
							</div>
						</div>
					))}

					<div className="absolute inset-x-0 bottom-10 z-40 flex items-center justify-center gap-2">
						{slides.map((_, idx) => (
							<span
								key={`indicator-${idx}`}
								className={`h-1 w-14 overflow-hidden rounded-full bg-white/30 transition-all duration-500 ${idx === activeIndex ? "bg-white shadow-[0_0_25px_rgba(255,255,255,0.6)] scale-110" : ""}`}
							/>
						))}
					</div>
				</div>
			</div>

			<section className="bg-gradient-to-b from-sky-50 to-white">
				<div className="container-gg grid items-center gap-10 py-14 md:grid-cols-2 md:py-20">
					<div>
						{/* <h1 className="text-3xl font-extrabold leading-tight text-slate-900 sm:text-4xl md:text-5xl">A vibrant day &amp; for Nursery to Secondary and boarding community for secondary</h1> */}
						<p className="mt-4 text-base text-slate-600 md:text-lg">
							GreatGrace Int&apos;l School partners with families to grow confident, creative and compassionate learners. Day school is available from Nursery through Secondary, while our caring boarding house welcomes Secondary students who want a fully immersive experience.
						</p>
						<ul className="mt-6 flex flex-wrap gap-3 text-sm text-slate-600">
							<li className="rounded-full border border-slate-200 px-4 py-1">Holistic academics &amp; faith-based values</li>
							<li className="rounded-full border border-slate-200 px-4 py-1">STEM, arts &amp; leadership pathways</li>
							<li className="rounded-full border border-slate-200 px-4 py-1">Dedicated boarding for Secondary</li>
						</ul>
						<div className="mt-6 flex flex-wrap items-center gap-3">
							<Link to="/admissions" className="btn-primary">Enroll Today</Link>
							<Link to="/about" className="btn-secondary">Discover Our Story</Link>
						</div>
					</div>
					<div className="relative h-80 w-full max-w-xl mx-auto overflow-hidden rounded-2xl">
						{sectionImages.map((img, idx) => (
							<img
								key={img.src}
								src={img.src}
							
								alt={img.alt}
								className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ease-in-out ${
									idx === sectionImageIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
								}`}
							/>
						))}
					</div>
				</div>
			</section>
		</>
	)
}


